<template>
    <div v-if="allowed">
        <page-card :header="this.mode.title">
            <b-row>
                <b-col sm="5" md="3" class="my-1">
                    <b-form-group
                        label="Per page"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        content-cols-md="3"
                        class="mb-0">
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                            size="md"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="7" md="6" class="my-1">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        size="md"
                        class="my-0"
                    ></b-pagination>
                </b-col>
                <b-col sm="7" md="3" class="my-1">
                    <b-form-group
                        label="Filter"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="md"
                        class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input
                                id="filter-input"
                                v-model="filter"
                                type="search"
                                placeholder="Type to Search"></b-form-input>

                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter=''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table striped hover :items="paths" :fields="fields" v-if="hasPaths"
                             :current-page="currentPage"
                             :per-page="perPage"
                             :filter="filter"
                             @filtered="onFiltered">
                        <template #cell(name)="row">
                            {{ row.value }}
                        </template>

                        <template #cell(status_code)="row">
                            <span v-if="row.item.success !== null" class="badge" :class="{
                                'badge-success': row.item.success,
                                'badge-warning': !row.item.success
                             }"
                                  v-b-tooltip.hover :title="row.item.status_created_at">
                                {{ row.item.status_code }}
                            </span>
                        </template>

                        <template #cell(shortcut)="row">
                            <a :href="row.item.url" target="_blank" class="btn btn-block"
                               :class="{
                                'disabled': !row.item.enabled,
                                'btn-success': row.item.enabled,
                                'btn-dark':!row.item.enabled}">
                                {{ row.value }}
                            </a>
                        </template>

                        <template #cell(actions)="row">
                            <a href="#" v-if="!row.item.enabled" v-on:click="enablePath(row.item.id)"
                               v-b-tooltip.hover :title="$t('pages.url-shortener-admin.enable')"
                               class="btn btn-primary"><i
                                class="fas fa-check-square"></i></a>
                            <a href="#" v-on:click="setPathToBeDeleted(row.item.id, row.item.shortcut)"
                               v-b-tooltip.hover :title="$t('pages.url-shortener.delete')"
                               v-b-modal.modalDeleteUrlShortenerAdmin
                               class="my-1 btn btn-danger"><i
                                class="fas fa-trash"></i></a>
                        </template>
                    </b-table>


                    <b-modal id="modalDeleteUrlShortenerAdmin"
                             :title="$t('pages.url-shortener.delete')"
                             title-tag="h3"
                             :ok-title="$t('common.confirmation')"
                             :cancel-title="$t('common.cancel')"
                             @ok="deletePath(deletablePath.id)">

                        <div>
                            {{ $t('pages.url-shortener.confirm_deletion', {shortcut: deletablePath.shortcut}) }}
                        </div>
                    </b-modal>


                    <!-- If there are not paths -->
                    <callout class="callout callout-warning" v-if="!hasPaths">
                        {{ $t('pages.url-shortener-admin.no_paths') }}
                    </callout>

                    <b-button variant="outline-primary"
                              href="#"
                              @click="switchMode()">{{ mode.btn_text }}
                    </b-button>

                </b-col>
            </b-row>
        </page-card>
    </div>
</template>

<script>
import GenericNotification from "../layout/GenericNotification";
import LoadingInjector from "../../mixins/LoadingInjector";
import PageCard from "../layout/PageCard";
import Callout from "../layout/Callout";
import shared from "../../util/shared";

export default {
    name: "url-shortener-admin",
    mixins: [
        LoadingInjector,
    ],
    components: {
        GenericNotification,
        PageCard,
        Callout,
    },
    props: {
        rzaccount: null,
        allowed: false,
    },
    data: function () {
        return {
            paths: {},
            fields: [
                {key: 'shortcut', label: this.$t('pages.url-shortener.shortcut')},
                {key: 'status_code', label: this.$t('pages.url-shortener.status_code')},
                {key: 'url', label: this.$t('pages.url-shortener.url')},
                {key: 'actions', label: ''},
            ],
            currentPage: 1,
            perPage: 25,
            pageOptions: [10, 25, 50, 100],
            filter: '',
            totalRows: 0,
            deletablePath: {
                shortcut: null,
                id: null,
            },
            mode: {
                type: "unenabled",
                title: this.$t('pages.url-shortener-admin.mode.unenabled.title'),
                btn_text: this.$t('pages.url-shortener-admin.mode.unenabled.btn_text'),
            },
        }
    },
    created() {
        console.log(`Mouted ${this.$options.name}.`);
        this.errorHandler = this.$shared.errorHandlerForResponder;
        this.fetchPathsToBeEnabled();
    },
    watch: {
        mode(newMode, oldMode) {
            if (newMode.type !== oldMode.type) {
                this.fetchPathsToBeEnabled();
            }
        }
    },
    computed: {
        hasPaths: function () {
            return this.paths.length > 0;
        }
    },
    methods: {
        fetchPathsToBeEnabled: function () {
            if (!this.allowed) {
                return;
            }

            let url = this.$Bologna.secure_url(`/v1/url-shortener/${this.mode.type}/`);
            this.$http.get(url)
                .then(response => {
                    let x = response.data.data.paths.map((path) => {
                        let r = {
                            'id': path.id,
                            'shortcut': this.$purify.sanitize(path.shortcut),
                            'url': this.$purify.sanitize(path.url),
                            'enabled': path.enabled === 1,
                        };
                        if (path.hasOwnProperty('checks') && path.checks.length === 1) {
                            r.success = path.checks[0].success;
                            r.status_code = path.checks[0].status_code;
                            r.status_created_at = new Date(path.checks[0].created_at).toLocaleString("de-DE");
                        } else {
                            r.success = null;
                            r.status_code = null;
                            r.status_created_at = null;
                        }
                        return r;
                    });
                    this.paths = (x === undefined) ? {} : x;
                    this.totalRows = this.paths.length;
                })
                .catch(err => {
                    console.log(this.errorHandler(err));
                })
        },
        setPathToBeDeleted: function (id, shortcut) {
            this.deletablePath = {
                shortcut: shortcut,
                id: id,
            };
        },
        enablePath: function (id) {
            let url = this.$Bologna.secure_url(`/v1/url-shortener/enable/${id}`);
            this.$http.post(url, {
                id: id
            })
                .then(response => {

                })
                .catch(err => {
                    this.errorHandler(err);
                })
                .finally(() => {
                    this.fetchPathsToBeEnabled();
                })
        },
        switchMode: function () {
            if (this.mode.type === 'unenabled') {
                this.mode = {
                    type: "all",
                    title: this.$t('pages.url-shortener-admin.mode.all.title'),
                    btn_text: this.$t('pages.url-shortener-admin.mode.all.btn_text')
                }
                return true;
            }

            if (this.mode.type === 'all') {
                this.mode = {
                    type: "unenabled",
                    title: this.$t('pages.url-shortener-admin.mode.unenabled.title'),
                    btn_text: this.$t('pages.url-shortener-admin.mode.unenabled.btn_text')
                }
                return true;
            }
        },
        deletePath: function (id) {
            let url = this.$Bologna.secure_url(`/v1/url-shortener/delete/${id}`);
            this.$http.post(url, {})
                .then(response => {

                })
                .catch(err => {

                })
                .finally(() => {
                    this.fetchPathsToBeEnabled();
                })
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        }
    },

};
</script>
